import React, {Component} from 'react';
import './ListItem.scss';
import {IntlProvider} from "react-intl";
import {ReactComponent as LockIcon} from '../../assets/Icons/lock.svg';
import {NavLink} from "react-router-dom";

class ListItem extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const lock = this.props.locked ? <div className="lock">
                <LockIcon/>
        </div> : "";
        return (
            <div
                className={"ListItem"+(this.props.marked? " marked":"") + (this.props.locked ? " locked" : "")}
                ref={(this.props.marked ? this.props.forwardRef : null)}
            >
                <NavLink to={this.props.navlink}>
                    <div className={"image"} style={{backgroundImage: "url("+this.props.image+")"}}/>
                    <div className={"otherStuff"}>
                        <div className={"title"}>{this.props.numbered ? this.props.numbered + ". " + this.props.title : this.props.title}</div>
                        <div className={"subtitle"}>{this.props.subtitle}</div>
                        {lock}
                    </div>
                </NavLink>
            </div>
        );
    }
}


export default ListItem;
